import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import {
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalService,
} from '@azure/msal-angular';
import { provideLottieOptions } from 'ngx-lottie';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { environment } from 'src/environments/environment';
import { MSALInstanceFactory } from '../msal-config';
import { AppResource } from './app.resource';
import { routes } from './app.routes';
import { AuthBearerInterceptor } from './shared/interceptor/bearer.interceptor';
import { MSALInterceptorConfigFactory } from './shared/interceptor/msal.interceptor';
import { AppInsightsService } from './shared/services/app-insight.service';
import { WINDOW_PROVIDERS } from './shared/services/window.service';

export function initResource(resource: AppResource) {
  return () => resource.load(environment.brand);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(BrowserModule),
    provideLottieOptions({
      player: () => import('lottie-web'),
    }),
    provideAnimations(),
    AppResource,
    AppInsightsService,
    ...WINDOW_PROVIDERS,
    {
      provide: APP_INITIALIZER,
      useFactory: initResource,
      deps: [AppResource],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthBearerInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    MsalService,
    MsalBroadcastService,
    MessageService,
    DialogService,
  ],
};
